import { Component, inject, OnInit } from '@angular/core';
import { IonContent, IonHeader, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { LoadingSpinnerComponent, LogoComponent } from '@work-frontend-monorepo/work-ui/layout';
import { ProfileState } from '@work-frontend-monorepo/work-ui/state-management';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'sfg-app-global-starting-screen-page',
  templateUrl: './global-app-starting-screen-page.component.html',
  styleUrls: ['./global-app-starting-screen-page.component.scss'],
  standalone: true,
  imports: [IonContent, ReactiveFormsModule, LogoComponent, LoadingSpinnerComponent, IonHeader, IonTitle, IonToolbar, TranslatePipe],
})
export class GlobalAppStartingScreenPageComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly router = inject(Router);

  async ngOnInit() {
    const startTime = Date.now();

    this.store.select(ProfileState.isLoggedIn).subscribe(async (isLoggedIn) => {
      const elapsedTime = Date.now() - startTime;
      const remainingTime = Math.max(0, 1000 - elapsedTime);

      await new Promise((resolve) => setTimeout(resolve, remainingTime));

      if (isLoggedIn) {
        await this.router.navigate(['/mitarbeitende/home'], { replaceUrl: true });
      } else {
        await this.router.navigate(['/start'], { replaceUrl: true });
      }
    });
  }
}
